"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7187],{

/***/ 5426:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/nubrakes-van-house-800-num.3fec1ca8.jpg","height":571,"width":1003,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAP/xAAeEAABBAEFAAAAAAAAAAAAAAABAAIDEQUGISIxYf/EABUBAQEAAAAAAAAAAAAAAAAAAAID/8QAFxEBAQEBAAAAAAAAAAAAAAAAAQACMf/aAAwDAQACEQMRAD8AloyspkG48vlhAYS6Vj+ZHdDagL8KIinsBl2//9k=","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 28763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ HappinessGuaranteeSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67814);
/* harmony import */ var _fortawesome_pro_duotone_svg_icons_faShieldCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68481);
/* harmony import */ var _Container__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3210);





var HappinessGuaranteeSection = function(param) {
    var description = param.description, title = param.title, _backgroundColor = param.backgroundColor, backgroundColor = _backgroundColor === void 0 ? "#fff3f0" : _backgroundColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "text-center",
        style: {
            backgroundColor: backgroundColor
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Container__WEBPACK_IMPORTED_MODULE_3__/* .Container */ .W, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__/* .FontAwesomeIcon */ .G, {
                    icon: _fortawesome_pro_duotone_svg_icons_faShieldCheck__WEBPACK_IMPORTED_MODULE_4__/* .faShieldCheck */ .ip,
                    color: "#f04f23",
                    size: "7x"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                    className: "py-4 title",
                    children: title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "description",
                    children: description
                })
            ]
        })
    });
};


/***/ }),

/***/ 17743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ LandingPageButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68663);
/* harmony import */ var _hooks_useQueryParam__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73401);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);








function LandingPageButton(props) {
    var query = (0,_hooks_useQueryParam__WEBPACK_IMPORTED_MODULE_4__/* .useQueryParam */ .W)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: {
            pathname: "/get-quote/",
            query: query
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                className: classnames__WEBPACK_IMPORTED_MODULE_5___default()(props.className),
                style: {
                    paddingTop: 8,
                    paddingBottom: 8,
                    paddingLeft: 25,
                    paddingRight: 25
                }
            }, props.buttonProps), {
                children: props.buttonText
            }))
        })
    });
}


/***/ }),

/***/ 18405:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ ReviewsV2Section; }
/* harmony export */ });
/* unused harmony export V2Review */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67814);
/* harmony import */ var _fortawesome_free_solid_svg_icons_faQuoteLeft__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(55502);
/* harmony import */ var _Container__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3210);
/* harmony import */ var react_responsive_carousel__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10615);
/* harmony import */ var _SEMPage_StarsAndRatings__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(39925);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var capital_case__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(71292);










var ReviewsV2Section = function(param) {
    var first = param.first, second = param.second, third = param.third, title = param.title;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Container__WEBPACK_IMPORTED_MODULE_3__/* .Container */ .W, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "text-center pb-5",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        children: title
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "md:hidden",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_responsive_carousel__WEBPACK_IMPORTED_MODULE_4__/* .Carousel */ .lr, {
                        showThumbs: false,
                        showStatus: false,
                        showArrows: false,
                        autoPlay: true,
                        infiniteLoop: true,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(V2Review, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, first)),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(V2Review, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, second)),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(V2Review, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, third))
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "hidden md:grid md:grid-cols-3 gap-4",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(V2Review, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, first))
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(V2Review, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, second))
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(V2Review, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, third))
                        })
                    ]
                })
            ]
        })
    });
};
var V2Review = function(param) {
    var review = param.review, from = param.from, reviewer = param.reviewer;
    var query = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)().query;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        style: {
            marginBottom: 40
        },
        className: "flex flex-col h-100",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex flex-col items-center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex flex-col justify-center items-center",
                    style: {
                        backgroundColor: "#ededed",
                        width: "60px",
                        height: "60px",
                        border: "1px solid #dcdbd",
                        borderRadius: 50,
                        zIndex: 1
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__/* .FontAwesomeIcon */ .G, {
                        icon: _fortawesome_free_solid_svg_icons_faQuoteLeft__WEBPACK_IMPORTED_MODULE_8__/* .faQuoteLeft */ .y1,
                        color: "#f04f23",
                        transform: "grow-9"
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                style: {
                    marginTop: "-30px",
                    border: "1px solid #dcdbdb"
                },
                className: "flex flex-col px-4 py-5 h-100",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        children: '"'.concat(review, '"')
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SEMPage_StarsAndRatings__WEBPACK_IMPORTED_MODULE_5__/* .StarsAndRatings */ .G, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: "reviewer",
                        children: [
                            "- ".concat(reviewer, " "),
                            query && query.city && ", ".concat((0,capital_case__WEBPACK_IMPORTED_MODULE_9__/* .capitalCase */ .I)(query.city)),
                            !query.city && from && ", ".concat(from)
                        ]
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 79610:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export HeaderSection */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Forms_ScheduleServiceMultiStep_NoEmailScheduleServiceFormMultiStep__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42786);
/* harmony import */ var _Container__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3210);
/* harmony import */ var _StarsAndRatings__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(39925);
/* harmony import */ var _hooks_useQueryParam__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73401);
/* harmony import */ var _public_img_nubrakes_van_house_800_num_jpg__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5426);









var HeaderSection = function(param) {
    var title = param.title, subtitle = param.subtitle, rating = param.rating, reviewCount = param.reviewCount;
    var query = (0,_hooks_useQueryParam__WEBPACK_IMPORTED_MODULE_7__/* .useQueryParam */ .W)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "py-0 text-white",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "py-[6%] flex flex-col justify-center align-center relative w-full h-full min-h-[60vh]",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                    src: _public_img_nubrakes_van_house_800_num_jpg__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z,
                    placeholder: "blur",
                    layout: "fill",
                    objectFit: "cover",
                    objectPosition: "bottom center",
                    priority: true,
                    alt: "NuBrakes Mobile Repair Header Image"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    id: "overlay",
                    style: {
                        minHeight: "100%",
                        width: "100%",
                        position: "absolute",
                        zIndex: 1,
                        backgroundColor: "rgba(0,0,0,.75)"
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    style: {
                        zIndex: 2
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Container__WEBPACK_IMPORTED_MODULE_5__/* .Container */ .W, {
                        className: "text-center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "grid lg:grid-cols-2 gap-4",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "text-center lg:text-left flex flex-col justify-center",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                            className: "text-2xl mt-4 md:mt-0 px-4 md:px-0 sm:text-2xl md:text-4xl text-white sm:mb-0",
                                            children: title
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "subheading text-white",
                                            children: subtitle ? subtitle : "We save our customers 40% on average over shop prices — book affordable repairs without leaving your home."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            style: {
                                                backgroundColor: "rgba(0, 0, 0, 0.69)",
                                                borderRadius: 6
                                            },
                                            className: "p-3 flex-col flex-grow-0 md:flex hidden mr-auto text-center",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_StarsAndRatings__WEBPACK_IMPORTED_MODULE_6__/* .StarsAndRatings */ .G, {}),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                    style: {
                                                        color: "#cbd0d3",
                                                        lineHeight: 1
                                                    },
                                                    children: [
                                                        "NuBrakes is rated ".concat(rating, "/5 by "),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                            href: {
                                                                pathname: "/reviews/",
                                                                query: query
                                                            },
                                                            prefetch: false,
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                style: {
                                                                    color: "#cbd0d3",
                                                                    textDecoration: "underline"
                                                                },
                                                                children: "".concat(reviewCount, " brake repair customers")
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "mt-2",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            style: {
                                                backgroundColor: "white"
                                            },
                                            className: "flex flex-col p-4 pb-6 mt-0",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Forms_ScheduleServiceMultiStep_NoEmailScheduleServiceFormMultiStep__WEBPACK_IMPORTED_MODULE_4__/* .NoEmailScheduleServiceFormMultiStep */ .D1, {})
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "mt-3 block md:hidden",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                style: {
                                                    backgroundColor: "rgba(0, 0, 0, 0.69)",
                                                    borderRadius: 6
                                                },
                                                className: "inline-block px-3 py-2",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_StarsAndRatings__WEBPACK_IMPORTED_MODULE_6__/* .StarsAndRatings */ .G, {}),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                        style: {
                                                            color: "#cbd0d3",
                                                            lineHeight: 1
                                                        },
                                                        children: [
                                                            "NuBrakes is rated ".concat(rating, "/5 by "),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                                href: {
                                                                    pathname: "/reviews/",
                                                                    query: query
                                                                },
                                                                prefetch: false,
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                    style: {
                                                                        color: "#cbd0d3",
                                                                        textDecoration: "underline"
                                                                    },
                                                                    children: "".concat(reviewCount, " brake repair customers")
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeaderSection);


/***/ }),

/***/ 43906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ HowItWorksGreenCheckSection; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59417);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67814);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _Container__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3210);






var HowItWorksGreenCheckSection = function(param) {
    var first = param.first, second = param.second, third = param.third, title = param.title, _locale = param.locale, locale = _locale === void 0 ? "en" : _locale;
    var defaultCopy = locale === "es" ? {
        title: "\xbfPor qu\xe9 NuBrakes?",
        first: {
            title: "Vamos a ti",
            subtitle: "Nuestros t\xe9cnicos m\xf3viles ofrecen reparaciones de frenos con excelentes calificaciones en tu casa u oficina por hasta 40% menos que un taller."
        },
        second: {
            title: "Mejores precios",
            subtitle: "En promedio somos 40% m\xe1s accesibles que concesionarios y talleres, as\xed que ahorras tiempo y dinero."
        },
        third: {
            title: "Disponibilidad el mismo d\xeda",
            subtitle: "\xbfNecesitas reparar tus frenos hoy? Normalmente hay servicio el mismo d\xeda — cont\xe1ctanos para agendar."
        }
    } : {
        title: "Why NuBrakes?",
        first: {
            title: "We Come To You",
            subtitle: "Our mobile brake techs deliver top-rated brake repairs at your home or office for up to 40% less than a repair shop."
        },
        second: {
            title: "Better Prices",
            subtitle: "We're 40% more affordable on average compared to the dealerships and shops so you'll be saving time and money."
        },
        third: {
            title: "Same-Day Availability",
            subtitle: "Need your brakes repaired today? Same-day service is typically available — contact us to schedule!"
        }
    };
    var resolvedTitle = title !== null && title !== void 0 ? title : defaultCopy.title;
    var resolvedFirst = first !== null && first !== void 0 ? first : defaultCopy.first;
    var resolvedSecond = second !== null && second !== void 0 ? second : defaultCopy.second;
    var resolvedThird = third !== null && third !== void 0 ? third : defaultCopy.third;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Container__WEBPACK_IMPORTED_MODULE_3__/* .Container */ .W, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "text-center mb-5",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        children: resolvedTitle
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "grid md:grid-cols-3",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GreenCheckHowItWorks, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, resolvedFirst)),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GreenCheckHowItWorks, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, resolvedSecond)),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GreenCheckHowItWorks, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, resolvedThird))
                    ]
                })
            ]
        })
    });
};
var GreenCheckHowItWorks = function(param) {
    var title = param.title, subtitle = param.subtitle;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-row",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mr-2",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
                    icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_5__/* .faCheckCircle */ .f8k,
                    style: {
                        fontWeight: 100
                    },
                    size: "2x",
                    color: "#14d90d"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        children: subtitle
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 1948:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ ServicesHowItWorksSection; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67814);
/* harmony import */ var _utils_string_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2638);
/* harmony import */ var _Container__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3210);
/* harmony import */ var _LandingPageButton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17743);
/* harmony import */ var _GraySection__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18737);









var ServicesHowItWorksSection = function(param) {
    var title = param.title, description = param.description, steps = param.steps, buttonText = param.buttonText, phoneNumber = param.phoneNumber;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_GraySection__WEBPACK_IMPORTED_MODULE_5__/* .GraySection */ .g, {
        className: "text-center",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Container__WEBPACK_IMPORTED_MODULE_3__/* .Container */ .W, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "title",
                            children: title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "description",
                            children: description
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "grid md:grid-cols-3",
                    style: {
                        background: "white",
                        boxShadow: "0 13px 27px -5px rgba(50, 50, 93, .25), 0 8px 16px -8px rgba(0, 0, 0, .3), 0 -6px 16px -6px rgba(0, 0, 0, .025)"
                    },
                    children: steps.map(function(value, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HowItWorksStep, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, value), {
                            stepImage: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__/* .FontAwesomeIcon */ .G, {
                                size: "4x",
                                color: "#ea3616",
                                icon: value.image
                            })
                        }), index);
                    })
                }),
                buttonText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "pt-5",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LandingPageButton__WEBPACK_IMPORTED_MODULE_4__/* .LandingPageButton */ .K, {
                        buttonText: buttonText
                    })
                }),
                phoneNumber && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "mt-2",
                    children: [
                        "Or call us at ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "tel:".concat(phoneNumber),
                            children: (0,_utils_string_utils__WEBPACK_IMPORTED_MODULE_8__/* .formatPhoneNumber */ .u)(phoneNumber)
                        })
                    ]
                })
            ]
        })
    });
};
var HowItWorksStep = function(param) {
    var title = param.title, description = param.description, stepImage = param.stepImage;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "py-4 flex flex-grow-1 flex-col h-100 text-center px-6",
        style: {
            border: "1px solid #dddddd"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mx-auto",
                children: stepImage
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mt-3",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "description",
                        children: description
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 39925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ StarsAndRatings; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_star_rating_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64396);
/* harmony import */ var react_star_rating_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_star_rating_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67814);
/* harmony import */ var _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59417);




var StarsAndRatings = function(param) {
    var withPoints = param.withPoints;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
        className: "mt-1 flex items-center justify-center",
        style: {
            lineHeight: 1
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_star_rating_component__WEBPACK_IMPORTED_MODULE_1___default()), {
                name: "rating",
                value: 5,
                starCount: 5,
                starColor: "gold",
                editing: false,
                renderStarIcon: function(index, value) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: index <= value ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__/* .FontAwesomeIcon */ .G, {
                            icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_3__/* .faStar */ .Tab,
                            color: "gold"
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__/* .FontAwesomeIcon */ .G, {
                            icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_3__/* .faStar */ .Tab,
                            color: "gold"
                        })
                    });
                },
                renderStarIconHalf: function() {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__/* .FontAwesomeIcon */ .G, {
                            icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_3__/* .faStarHalf */ .eJY,
                            color: "gold"
                        })
                    });
                }
            }),
            withPoints && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "text-white font-bold ml-2",
                children: "4.9"
            })
        ]
    });
};


/***/ }),

/***/ 10090:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ getTitleFromUTMS; }
/* harmony export */ });
/* harmony import */ var capital_case__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71292);

var getTitleFromUTMS = function(param) {
    var type = param.type, formalCity = param.formalCity, content = param.content, make = param.make;
    switch(type){
        case "generic":
            return "The Best ".concat(content, " Mobile Brake Repair in ").concat(formalCity, " — We Come To You.");
        case "comp":
            return "Don't Waste Time At A ".concat(capital_case__WEBPACK_IMPORTED_MODULE_0__/* .capitalCase */ .I(content), " — We Come To You");
        case "vehicle":
            return "The Best ".concat(capital_case__WEBPACK_IMPORTED_MODULE_0__/* .capitalCase */ .I(make), " Brake Repair In ").concat(formalCity, "  — We Come To You");
        case "vehicle-part":
            return "Our ".concat(formalCity, " Brake Techs Replace ").concat(capital_case__WEBPACK_IMPORTED_MODULE_0__/* .capitalCase */ .I(make), " ").concat(capital_case__WEBPACK_IMPORTED_MODULE_0__/* .capitalCase */ .I(content), " For Less!");
        case "mm_generic":
            return "The Best Mobile Mechanics in ".concat(formalCity, " — We Come To You");
        case "mm_vehicle-part":
            return "Our ".concat(formalCity, " Mobile Mechanics Replace ").concat(make && capital_case__WEBPACK_IMPORTED_MODULE_0__/* .capitalCase */ .I(make), " ").concat(capital_case__WEBPACK_IMPORTED_MODULE_0__/* .capitalCase */ .I(content), " For Less!");
        default:
            return "The Best Mobile Brake Repair in ".concat(formalCity, " — We Come To You.");
    }
};


/***/ })

}]);